import React from 'react';

import { tailwindMerge } from '../../../../tailwind';

export type HeaderTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export type HeaderSize = 'm' | 'l' | 'xl' | 'xxl' | '3xl' | '4xl' | '5xl';

export interface HeaderProps extends React.ComponentPropsWithRef<'h1'> {
  tag: HeaderTag;
  size?: HeaderSize;
  className?: string;
}

export const getHeaderClass = (size: HeaderSize = 'm') => {
  switch (size) {
    case 'm':
      return 'text-m font-semibold';
    case 'l':
      return 'text-l leading-m font-semibold';
    case 'xl':
      return 'text-xl font-semibold';
    case 'xxl':
      return 'text-xxl font-semibold';
    case '3xl':
      return 'text-3xl font-semibold';
    case '4xl':
      return 'text-4xl font-semibold';
    case '5xl':
      return 'text-5xl font-bold';
  }
};

export const Header = React.forwardRef<HTMLHeadingElement, HeaderProps>(
  ({ className, tag: Tag, size, children, ...props }, ref) => (
    <Tag
      className={tailwindMerge('m-zero', getHeaderClass(size), className)}
      {...props}
      ref={ref}
    >
      {children}
    </Tag>
  ),
);
